import { UserContext } from 'shared-types/user';

import { TslLogo } from './B2bPlayerArea.style';
import { BamPromoImage } from './BamPromoImages';

export const PlaceholderLogoStrategy = (userContext: UserContext) => {
  const components = {
    [UserContext.BAM]: <BamPromoImage promoImage='first' />,
    [UserContext.TSL]: <TslLogo />,
    [UserContext.BKO]: <TslLogo />,
  };

  return components[userContext];
};
